/**
 * @module common
 * @name mdFeelBenefitsService
 * @type service
 * @description Servicio para el manejo de la lógica de beneficios de Massimo Dutti Feel
 */
(function () {
    'use strict';

    angular.module('itxApp.common').factory('mdFeelBenefitsService', mdFeelBenefitsService);

    mdFeelBenefitsService.$inject = ['$q', 'CmsConfigSvc'];

    function mdFeelBenefitsService($q, CmsConfigSvc) {
        var service = {
            getWhatsAppInfo: _getWhatsAppInfo
        };

        return service;

        /**
         * Función para obtener la configuración del contacto por Whatsapp
         */
        function _getWhatsAppInfo() {
            var deferred = $q.defer();
            CmsConfigSvc.getProperty('whatsapp').then(function (res) {
                if (res.enabled) {
                    if (inditex.isMobileDevice()) {
                        res.link = 'https://wa.me/' + res.phoneNumber;
                    } else {
                        res.link = 'https://web.whatsapp.com/send?phone=' + res.phoneNumber;
                    }

                    if (res.target && res.target == 'FEEL' && !service.is360()) {
                        res.link = false;
                    }
                }
                deferred.resolve(res);
            });

            return deferred.promise;
        }
    }
})();
